import React from 'react'
import './AssessmentQuestionsCategoryName.scss'
import { InputRowDescription } from 'hub-web-lib'

const AssessmentQuestionsCategoryName = ({ category }) => {
    return (
        <div className='questions-category-name'>
            <h3>
                <i className='icon-folder'></i>
                <span className='category-name'>{category?.name}</span>
                <InputRowDescription description={category?.description} />
            </h3>
        </div>
    )
}

export default AssessmentQuestionsCategoryName
